import React from 'react';
import { brandLogos } from '../data/mock';

const TrustBar = () => {
  return (
    <section className="bg-[#0B0B0B] border-y border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-[#9CA3AF] text-sm mb-8 uppercase tracking-widest">
          Trusted by Industry-Leading Brands
        </p>
        <div className="flex flex-wrap items-center justify-center gap-12 md:gap-16">
          {brandLogos.map((brand, index) => (
            <div
              key={brand.id}
              className="opacity-50 hover:opacity-100 transition-all duration-500 cursor-pointer grayscale hover:grayscale-0"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <span className="text-white text-xl md:text-2xl font-bold tracking-wider">
                {brand.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
